import { IAjaxConfig } from '../helpers';
/**
 *  微信 API 地址
 *  @swagger  https://tst-bpcentral.lenovo.com.cn/wechat/swagger-ui.html#/%E5%BE%AE%E4%BF%A1%E6%8E%88%E6%9D%83%E7%B1%BB%E6%8E%A5%E5%8F%A3
 */
export class EnumApiWechat {
  /**
   * @dec 生成jsap权限签名
   */
  readonly wechat_jsapi_sign: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-customer-bffsvr/wechat/auth/jsapi/sign',
    method: 'post',
    // loading: true
    // cache: true
  };
  /**
   * @dec 获取小程序 openid
   * @body jsCode
   */
  readonly wechat_weapp_session: IAjaxConfig = {
    url: '/api/gateway/wechat/public/mini/user/session/get',
  };
  /**
   * @dec 获取 openid
   */
  readonly wechat_login: IAjaxConfig = {
    url: '/wechat/auth/oauth/login',
    loading: true,
  };
  /**
   * @dec 获取 openid
   */
  readonly wechat_info: IAjaxConfig = {
    url: '/wechat/user/info/get',
    loading: true,
  };
  /**
   * @dec 发送模板消息
   */
  readonly wechat_send: IAjaxConfig = {
    url: '/wechat/msg/subscribe/send',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 生成T1用户绑定url
   * @method get
   * @params
   */
  readonly priceReview_subscriptionT1BusBoLink: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/wx/subscriptionT1BusBoLink',
    method: 'get',
  };

  /**
   * @dec 获取微信绑定用户
   * @method get
   * @params
   */
  readonly priceReview_bindUserInfo: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/wx/bindUserInfo',
    method: 'get',
  };

  /**
   * @dec 设置微信绑定用户消息提醒开关
   * @method get
   * @params
   */
  readonly priceReview_messageControl: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/messageControl',
    method: 'get',
  };

  /**
   * @dec 获取微信绑定用户消息提醒设置
   * @method get
   * @params
   */
  readonly priceReview_messageInfo: IAjaxConfig = {
    url: '/api/bpportal/pcsd-bp-bo/portal/priceReview/messageInfo',
    method: 'get',
  };
}
